import { Component, Inject } from '@angular/core';
import { SvgIconComponent } from "../../../ui/svg-icon/svg-icon.component";
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../../../services/nav.service';
import { LayoutService } from '../../../../services/layout.service'; // Import LayoutService

@Component({
  selector: 'app-toggle-screen',
  imports: [SvgIconComponent],
  templateUrl: './toggle-screen.component.html',
  styleUrl: './toggle-screen.component.scss'
})

export class ToggleScreenComponent {

  public elem: any;
  public url: string;

  constructor(
    @Inject(DOCUMENT) private document: any, 
    private navService: NavService,
    private layoutService: LayoutService  // Inject LayoutService
  ) {
    this.elem = document.documentElement;
    
    // Listen for fullscreen change events
    this.document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.addEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.addEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this));
  }

  handleFullscreenChange() {
    // Check if we're in fullscreen mode
    const isFullscreen = !!(
      this.document.fullscreenElement ||
      this.document.mozFullScreenElement ||
      this.document.webkitFullscreenElement ||
      this.document.msFullscreenElement
    );

    if (isFullscreen) {
      // Close sidebar when entering fullscreen
      this.layoutService.closeSidebar = true;
    } else {
      // Open sidebar when exiting fullscreen
      this.layoutService.closeSidebar = false;
    }
  }

  toggleScreen() {
    this.navService.fullScreen = !this.navService.fullScreen;
    if (this.navService.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  
  ngOnDestroy() {
    // Clean up event listeners
    this.document.removeEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this));
    this.document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this));
  }
}